import { ref, watch } from "vue";
import { type PrintersType } from "@lib/zod/Printers";

export const currentPrinters = ref<PrintersType>([]);
export const currentPrinter = ref<PrintersType[number] | null>(null);

// localStorage key for storing current printer
const CURRENT_PRINTER_KEY = 'currentPrinter';

// Load saved printer from localStorage
const loadSavedPrinter = (): PrintersType[number] | null => {
    try {
        const saved = localStorage.getItem(CURRENT_PRINTER_KEY);
        return saved ? JSON.parse(saved) : null;
    } catch (error) {
        console.warn('Failed to load saved printer from localStorage:', error);
        return null;
    }
};

// Save current printer to localStorage
const savePrinter = (printer: PrintersType[number] | null) => {
    try {
        if (printer) {
            localStorage.setItem(CURRENT_PRINTER_KEY, JSON.stringify(printer));
        } else {
            localStorage.removeItem(CURRENT_PRINTER_KEY);
        }
    } catch (error) {
        console.warn('Failed to save printer to localStorage:', error);
    }
};

// Watch for changes to currentPrinter and save to localStorage
watch(currentPrinter, (newPrinter) => {
    savePrinter(newPrinter);
}, { deep: true });

// Function to select printer from the list
const selectPrinter = (printers: PrintersType) => {
    if (printers.length === 0) {
        currentPrinter.value = null;
        return;
    }

    const savedPrinter = loadSavedPrinter();

    if (savedPrinter) {
        // Check if saved printer exists in current printer list (match by deviceName)
        const foundPrinter = printers.find(printer =>
            printer.deviceName === savedPrinter.deviceName
        );

        if (foundPrinter) {
            currentPrinter.value = foundPrinter;
            return;
        }
    }

    // Fallback to first printer if no saved printer or saved printer not found
    currentPrinter.value = printers[0];
};

export const getPrinters = function (): Promise<PrintersType> {
    return new Promise((resolve) => {
        console.warn("Failed to get printers, using fake printers");
        // fake it until make it
        const fakePrinters = [
            {
                "deviceName": "fake-printer",
                "printerDescription": "",
                "printerName": "fake-printer",
                "printerOptions": {
                    "printer-location": "",
                    "printer-make-and-model": "",
                    "system_driverinfo": ""
                }
            },
            {
                "deviceName": "2nd-fake-printer",
                "printerDescription": "",
                "printerName": "2nd-fake-printer",
                "printerOptions": {
                    "printer-location": "",
                    "printer-make-and-model": "",
                    "system_driverinfo": ""
                }
            }
        ];
        currentPrinters.value = fakePrinters;
        selectPrinter(fakePrinters);
        resolve(fakePrinters);
    });
}

getPrinters();